export default "__VITE_ASSET__C36EreS7__"